export default {
  NAME_DOSE_NOT_EXIST: "نام موجود نیست.",
  NAME_INVALID: "نام نامعتبر است.",

  CATEGORY_ID_NOT_EXIST: "گروه نمایش دهندگان موجود نیست.",
  CATEGORY_ID_INVALID: "گروه نمایش دهندگان نامعتبر است.",

  ACTIVE_ID_NOT_EXIST: "فعال بودن کمپین موجود نیست.",
  ACTIVE_ID_INVALID: "فعال بودن کمپین نامعتبر است.",

  ADD_CAMPAIGN_SUCCESS: "کمپین اضافه شد.",
  ADD_CAMPAIGN_FAILED: "اضافه کردن کمپین با شکست روبرو شد.",

  ID_INVALID: "شماره نامعتبر است..",

  GET_CAMPAIGN_FAILED: "گرفتن کمپین با شکست روبرو شد.",

  DELETE_CAMPAIGN_FAILED: "حذف کمپین با شکست روبرو شد.",
  DELETE_CAMPAIGN_SUCCESS: "کمپین حذف شد.",

  EDIT_CAMPAIGN_FAILED: "ویرایش کمپین با شکست روبرو شد.",
  EDIT_CAMPAIGN_SUCCESS: "کمپین ویرایش شد.",
  
  CHARGE_LESS_THAN_TOTAL_AMOUNT_CAMPAIGN: "موجودی  حساب شما کمتر مبلغ کل کمپین است.",
};
